import React, { useEffect, useState } from "react"
import { Box, Image, Text } from '../../../designSystem'
import { BonusStatsText, BonusUpperDiv, DailyBonusStats, InfoIcon, SubHeading, ClickHereText } from "./styles"
import Calendar from "./BonusCalendar"
import { Stats, Timer } from "../Cards/monthlyBookCard"
import PerformanceCard from "../Cards/performanceCard"
import { get } from "../../../lib/api"
import { months } from "../constants"
import { handleEventLog, numFormatter } from "../../../lib/utils"
import { ArrowWhite, AuthorName, BookAction, BookCard, BookTitle, ctaBox, descriptionCard, descriptionText, DetailsDiv, hr, TopSection } from "../style"
import Tooltip from "../../../CustomTooltip"
import { menuItemObj } from "../../../components/PrivatePage"
import { Popup } from "../../../components/Popup"
import LearnMorePopup from "./LearnMorePopup"
import RevenueShareVideoPopup from "./revenueShareVideoPopup"
import SeriesPerformanceCard from "../Cards/seriesPerformanceCard"

const DailyBonus = ({ bookDetails, author_name, history, user }) => {
    const [dailyBonusData, setDailyBonusData] = useState(null)
    const [openLearnMorePopup, setOpenLearnMorePopup] = useState(false)
    const [videoPopup, setVideoPopup] = useState(false)
    const isBelowBenchmark = bookDetails?.incentive_status === 'below_benchmark'
    const showDailyBonusCard = !!bookDetails?.eligible_for_incentive
    const incentiveStopDate = bookDetails?.incentive_stop_date
    const isUSUser = bookDetails?.is_novel === 2 || bookDetails?.program_type === 'writer_benefit_v3_us'
    useEffect(() => {
        showDailyBonusCard && 
        get(`/content_api/book.wbp_daily_incentive/${bookDetails.book_id}/?is_novel=1`)
          .then((res) => {
            setDailyBonusData(res)
          })
    },[])

    const handleIcentivePeriod = () => {
        if (!incentiveStopDate) return ""
        const today = new Date();
        const inputDate = new Date(incentiveStopDate);
    
        // Remove the time portion from the dates for accurate comparison
        today.setHours(0, 0, 0, 0);
        inputDate.setHours(0, 0, 0, 0);
    
        if (inputDate <= today) {
          return "incentive_stopped";
        } else if (inputDate > today) {
          return "incentive_in_stop_period"
        }
      }

    const handleLearnMore = () => {
        handleEventLog("home", "button_click", {
            module_name : "daily_update_bonus_Learn_more",
            entity_id : bookDetails.book_id,
            entity_type : 'book'
        })
        setOpenLearnMorePopup(true)
    }

    const isMobile = window.screen.width < 600
    const date = new Date()
    const todaysDate = `${("0" + date.getDate()).slice(-2)} ${months[date.getMonth()].substr(0,3)} ${date.getFullYear()}`.toString()
    const analyticsPageRedirectHTML = () => <span style={{color: 'blue', cursor: 'pointer'}} onClick={() => history.push(`/analytics?bookId=${bookDetails.book_id}`)}>here</span>
    return(
        <>
            {openLearnMorePopup && (
                <Popup
                    show
                    close={() => setOpenLearnMorePopup(false)}
                    className={''}
                    closeMarksStyles={{ top: '20%' }}
                >
                    <LearnMorePopup 
                      setOpenLearnMorePopup={setOpenLearnMorePopup} 
                      authorName={author_name}  
                      bookId={bookDetails.book_id}
                    />
                </Popup>
            )}
            <RevenueShareVideoPopup videoPopup={videoPopup} setVideoPopup={setVideoPopup} />
            <BookCard>
                <TopSection>
                    <Image 
                      onClick={() => history.push(`${menuItemObj.novels}/id/${bookDetails.book_id}?tab=draft`)} 
                      width={[40, 112]} 
                      height={[60, 168]} 
                      mr={[8, 24]} 
                      src={bookDetails.image_url} 
                    />
                    <DetailsDiv>
                    <BookTitle>{bookDetails.book_title}</BookTitle>
                    <AuthorName>{author_name}</AuthorName>
                    
                    {!isMobile && <Box {...ctaBox}>
                        <BookAction enabled={1} onClick={() => history.push(`${menuItemObj.novels}/id/${bookDetails.book_id}?tab=draft`)}>
                            {bookDetails.daily_tracker.chapter_missed ? "Add Today’s Chapter" : "Add New Chapter"}
                        </BookAction>
                    </Box>}
                    {!isMobile && bookDetails.daily_tracker.chapter_missed && <Timer />}
                    </DetailsDiv>
                </TopSection>
                {isMobile && <Box {...ctaBox}>
                    <BookAction enabled={1} onClick={() => {history.push(`${menuItemObj.novels}/id/${bookDetails.book_id}?tab=draft`);}}>
                        {bookDetails.daily_tracker.chapter_missed ? "Add Today’s Chapter" : "Add New Chapter"}
                        <ArrowWhite />
                    </BookAction>
                </Box>}
                {isMobile && bookDetails.daily_tracker.chapter_missed && <Timer />}

                {/* incentive eligible books */}
                {showDailyBonusCard && <Box {...descriptionCard}>
                  <Text {...descriptionText}>
                    {!isUSUser && <>Tip: We have noticed novels updating daily has 90% lesser readers dropping off. Don't forget to Publish quality chapters daily.</>} 
                    {isUSUser && <>Tip: We have noticed series updating daily has 90% lesser listeners dropping off. Don't forget to Publish quality chapters daily.</>} 
                  </Text>
                </Box>}
                
                {/* incentive not eligible books */}
                {!showDailyBonusCard && <Box {...descriptionCard}>
                  <Text {...descriptionText}>
                    {bookDetails?.sub_status !== 'open_for_withdrawal' && bookDetails?.language === 'hindi' && <>While the Daily Update Bonus and other incentives are not applicable at the moment due to the novel's current engagement level , we have an amazing alternative for you! You can still earn through our revenue share program after signing the contract. <ClickHereText onClick={()=> setVideoPopup(true)}>Click here</ClickHereText> for more details.</>} 
                    {bookDetails?.sub_status !== 'open_for_withdrawal' && bookDetails?.language !== 'hindi' && <>Contract process is in review. All rewards will be transferred to you, by the 2nd week of subsequent Month post-confirmation.</>} 
                    {bookDetails?.sub_status === 'open_for_withdrawal' && bookDetails?.language === 'hindi' && <>Daily update bonus is not applicable due to the novel's low engagement level. You can refer to your novel’s engagement data vs other Novels in the Program {analyticsPageRedirectHTML()} . But we have an amazing alternative for you! You can still earn through our revenue share program if you continue to write the novel. <ClickHereText onClick={()=> setVideoPopup(true)}>Click here</ClickHereText> for more details.</>} 
                    {bookDetails?.sub_status === 'open_for_withdrawal' && bookDetails?.language !== 'hindi' && <>We have stopped daily update bonus as this novel has very low retention, You can refer to your novel’s engagement data vs Novels in the Program {analyticsPageRedirectHTML()} You can still continue to earn via coins for the novel !</>} 
                  </Text>
                </Box>}

                {/* {bookDetails?.sub_status === 'signing_pending' && <Box {...descriptionCard}>
                    <Text {...descriptionText}>
                        While the Daily Update Bonus and other incentives are not applicable at the moment due to the novel's current engagement level , we have an amazing alternative for you! You can still earn through our revenue share program after signing the contract. <ClickHereText onClick={()=> setVideoPopup(true)}>Click here</ClickHereText> for more details
                    </Text>
                </Box>} */}
                {/* {bookDetails?.sub_status === 'open_for_withdrawal' && 
                   showDailyBonusCard && 
                   <>
                        {isUSUser && <Box {...descriptionCard}>
                            <Text {...descriptionText}>
                                Tip: We have noticed series updating daily has 90% lesser listeners dropping off. Keep up the great work ! & Don't forget to Publish quality chapters daily.
                            </Text>
                        </Box> }
                        {bookDetails?.incentive_status && <Box {...descriptionCard}>
                        <Text {...descriptionText}>
                            {
                                <>
                                    {isBelowBenchmark && <>Your Novel is in risk of losing daily update bonus due to low retention, please continue to upload daily with quality chapter content. You can refer to your novel’s engagement data vs Novels in the Program {analyticsPageRedirectHTML()}</>}
                                    {bookDetails?.incentive_status === 'at_risk' && <>Your Novel have lesser retention than top novels, please continue to upload daily with quality chapter content. You can refer to your novel’s engagement data vs Novels in the Program {analyticsPageRedirectHTML()}</>}
                                    {bookDetails?.incentive_status === 'above_benchmark' && <>Tip: We've discovered that novels that are updated daily have 90% fewer readers <strong>dropping off</strong>. Keep up the great work & Don't forget to publish quality chapters daily.</>}
                                    {bookDetails?.incentive_status === 'insufficient_data' && <>We don't have statistically significant data to classify your book’s retention yet. Please upload regularly with quality content to avoid loosing out on Daily Update Bonus in future.</>}
                                </>
                            }
                        </Text>
                        </Box>}
                   </> 
                } */}
                {/* {bookDetails?.sub_status === 'open_for_withdrawal' && 
                  !showDailyBonusCard && 
                    <Box {...descriptionCard}>
                      <Text {...descriptionText}>
                        {bookDetails?.language === 'hindi' ? 
                        <>
                            Daily update bonus is not applicable due to the novel's low engagement level. You can refer to your novel’s engagement data vs other Novels in the Program {analyticsPageRedirectHTML()} . But we have an amazing alternative for you! You can still earn through our revenue share program if you continue to write the novel. <ClickHereText onClick={()=> setVideoPopup(true)}>Click here</ClickHereText> for more details.
                        </> : 
                        <>
                            We have stopped daily update bonus as this novel has very low retention, You can refer to your novel’s engagement data vs Novels in the Program {analyticsPageRedirectHTML()} You can still continue to earn via coins for the novel !
                        </>}
                      </Text>
                    </Box>} */}
                {!showDailyBonusCard &&
                    <Stats
                        views={bookDetails.stats && bookDetails.stats.total_views}
                        chapters={bookDetails.chapters_count}
                        words={bookDetails.word_count}
                        likes={bookDetails?.stats?.likes}
                        comments={bookDetails?.stats?.comments} 
                    />
                } 
            </BookCard>
            {!!(showDailyBonusCard && dailyBonusData) && 
            <BonusUpperDiv>
                <Box backgroundColor="#fdfdfd" p={[16,24]} 
                    // width={['100%','50%']}
                >
                    <Box>
                        <Text variant="titleMedium">
                            <span style={{'margin-right': "2px"}}> Daily Update Bonus </span>
                            <Tooltip content="Publish at least 1 chapter & up to 2000 words today to achieve this reward" direction="bottom">
                                <InfoIcon />
                            </Tooltip>
                        </Text>
                    </Box>
                    {dailyBonusData?.higher_incentive_variant === 'B' && 
                      <SubHeading>
                        <span>प्रति माह 18,000 रुपये तक कमाने के लिए बिना रुके हर दिन Publish करें!</span>
                        {/* Congrats! upgraded to{' '} <span> 20 paise/ word </span> */}
                        <button onClick={handleLearnMore} >Learn More  {'>>'}</button>
                      </SubHeading>}
                    <Box mt={16}>
                      <Text variant="caption" fontWeight={600}>{todaysDate}</Text>
                    </Box>
                    <Box display="flex" gap={2}>
                        <Box display="flex" my={4} alignItems="center"mr={8}>
                            <DailyBonusStats>{numFormatter(dailyBonusData?.words_published || 0)}</DailyBonusStats>
                            <BonusStatsText>Words Published</BonusStatsText>
                        </Box>
                        <Box display="flex" my={4} alignItems="center">
                            <DailyBonusStats>{isUSUser ? '$' : '₹'}{Number.isInteger(dailyBonusData?.projected_reward || 0) ? (dailyBonusData?.projected_reward || 0) : (dailyBonusData?.projected_reward || 0).toFixed(2)}</DailyBonusStats>
                            <BonusStatsText>Projected Reward</BonusStatsText>
                        </Box>
                    </Box>
                    {/* <Box {...hr}/> */}
                    {/* <BonusCautionBox>
                            <BonusCautionText>Your base rate will drop by 50% for tomorrow if you miss publishing today!</BonusCautionText>
                    </BonusCautionBox> */}
                    {dailyBonusData && <Box mt={24}><Calendar publishedDates={dailyBonusData?.incentives_data || {}} wbpFirstOngoingDate={dailyBonusData?.wbp_ongoing_date} isUgcBook={isUSUser} /></Box>}
                </Box>
                <Box
                //  width={['100%','50%']}
                >
                    <Box backgroundColor="#fdfdfd" mb={8} p={[16,'24px 16px']}>
                        <Stats
                            views={bookDetails.stats && bookDetails.stats.total_views}
                            chapters={bookDetails.chapters_count}
                            words={bookDetails.word_count}
                            likes={bookDetails?.stats?.likes}
                            comments={bookDetails?.stats?.comments} 
                            newVersion
                        />
                    </Box>
                    <Box backgroundColor="#fdfdfd" p={[16,'24px']}>
                    {   
                        bookDetails?.is_novel === 2 ? 
                            <SeriesPerformanceCard bookId={bookDetails.book_id} newVersion/> :
                            <PerformanceCard bookId={bookDetails.book_id} newVersion/>
                    }
                    </Box>
                </Box>
            </BonusUpperDiv>}
            {console.log("showDailyBonusCard", showDailyBonusCard)}
            {!showDailyBonusCard && (
                bookDetails?.is_novel === 2 ? <SeriesPerformanceCard bookId={bookDetails.book_id}/> : <PerformanceCard bookId={bookDetails.book_id}/>
            )}
        </>
    )
}

export default DailyBonus